import React from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'

const GalleryContainer = styled.div`
  max-width: 90em;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 40em) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

const GalleryItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => props.justify};
  margin: 2rem 0;

  @media (min-width: 52em) {
    margin: 3rem -1rem;
  }
`

const GalleryImage = styled.div`
  width: 100%;
  justify-content: ${props => props.justify};

  @media (min-width: 52em) {
    width: ${props => props.w};
    order: ${props => props.order};
    padding-left: 1rem;
    padding-right: 1rem;
  }
`

const Caption = styled.div`
  width: 100%;
  padding: 1rem;
  color: #606060;
  font-size: .875rem;

  @media (min-width: 40em) {
    padding: 1rem 0;
  }

  @media (min-width: 52em) {
    width: 33.33333%;
    padding: 0 1rem;
  }

  @media (min-width: 64em) {
    font-size: 1rem;
  }
`

const Gallery = ({ img, index }) => {
  const order = index % 2
  let imgWidth = 2/3
  let justify = 'flex-start'

  if (order === 1)
    justify = 'flex-end'

  // Narrow container for portrait image
  if (img.image.sizes.aspectRatio < 1)
    imgWidth = 1/3

  return (
    <GalleryContainer>
      <GalleryItem justify={justify}>
        <GalleryImage order={order} justify={justify} w={(imgWidth * 100) + '%'}>
          <Img sizes={img.image.sizes} />
        </GalleryImage>
        <Caption dangerouslySetInnerHTML={{ __html: img.caption.childMarkdownRemark.html }} />
      </GalleryItem>
    </GalleryContainer>
  );
};

export default ({images}) => {
  if (images)
    return (
      <div>
        {images.map((img, index) => (
          <Gallery img={img} index={index} key={index} />
        ))}
      </div>
    )
  else
    return false
}



// WEBPACK FOOTER //
// ./src/components/gallery.js